import { ProcessingLoader } from "../Loader";
import styles from "./Processing.module.css";
import { Button } from "../Button";
import axios from "axios";
import { sendMessage } from "../../../context/utils";
import { useContext, useState } from "react";
import { RoutingContext } from "../../../context/Router";
import { StatusContext } from "../../../context/Status";

export const Processing = ({
  transactionRef,
  setTabDisplayed = () => console.log(""),
}: {
  transactionRef: string;
  setTabDisplayed?: (val: string) => void;
}) => {
  const { merchantKey } = useContext(RoutingContext);
  const { setPageTransactionStatus } = useContext(StatusContext);

  const [isPending, setIsPending] = useState(false);

  const onSubmit = async () => {
    if (transactionRef != "") {
      const payload = {
        txnRef: transactionRef,
      };

      try {
        const response = await axios({
          method: "post",
          url: `${process.env.REACT_APP_API_URL}nucleus/wordpressstatus/tnxrefStatus`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-auth-token": merchantKey,
          },
          data: payload,
        });
        const responseData = response.data;

        if (responseData["status"] === "successful") {
          setTabDisplayed("success");
          setPageTransactionStatus("success");
          const dataResp = { status: "successful" };
          setTimeout(() => {
            sendMessage(dataResp);
          }, 5000);
        } else if (
          responseData["status"].toLowerCase() === "pending" &&
          ["Charge initiated", "pending"].includes(responseData["message"])
        ) {
          setIsPending(true);
          return;
        } else {
          setTabDisplayed("error");
          setPageTransactionStatus("error");
          const dataResp = { status: "ERROR" };
          setTimeout(() => {
            sendMessage(dataResp);
          }, 5000);
        }
      } catch (error) {
        setTabDisplayed("error");
        setTimeout(() => {
          sendMessage({ status: "ERROR" });
        }, 5000);
      }
    }
  };

  return (
    <div className={styles.container}>
      <p className={styles.text}>
        {`${
          isPending
            ? "The payment is pending please try confirming in 5 minutes"
            : "Please wait, we're processing your transaction."
        }`}
      </p>
      <div className={styles.loader}>
        <ProcessingLoader />
      </div>
      <div className={styles.btnWrapper}>
        <Button
          type="button"
          text="I have paid"
          buttonStyle="primary"
          onClick={onSubmit}
        />
      </div>
    </div>
  );
};
